var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg24PxResourceOptimisation01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-resource-optimisation-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,14V8H16V2H8V8H5v6H2v8H22V14Zm-2-4v4H13V10h4ZM10,4h4V8H10ZM7,10h4v4H7ZM8,20H4V16H8Zm6,0H10V16h4Zm6,0H16V16h4Z",
    fill: "#242f47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24PxResourceOptimisation01);
export default __webpack_public_path__ + "static/media/24px-resource-optimisation-01.01b0860b8476b9bb9979df8aec4babb4.svg";
export { ForwardRef as ReactComponent };